import { createSlice } from '@reduxjs/toolkit';
import { Dimensions } from '../../shared';

type CanvasState = {
  dimensions: Dimensions;
  playing: boolean;
  frame: number;
}

export const INITIAL_STATE: CanvasState = {
  dimensions: {
    width: 0,
    height: 0
  },
  playing: false,
  frame: 0,
};

export const canvas = createSlice({
  name: 'canvas',
  initialState: INITIAL_STATE,
  reducers: {
    resetCanvas: (state) => {
      for (const key in INITIAL_STATE) {
        (state as any)[key] = (INITIAL_STATE as any)[key];
      }
    },
    setCanvasState: (state, action) => {
      const _state = action.payload;
      for (const key in INITIAL_STATE) {
        if (key in _state) {
          (state as any)[key] = (_state as any)[key];
        } else {
          (state as any)[key] = (INITIAL_STATE as any)[key];
        }
      }
    },
    setDimensions: (state, action) => {
      state.dimensions = action.payload;
    },
    setPlaying: (state, action) => {
      state.playing = action.payload;
    },
    setFrame: (state, action) => {
      state.frame = action.payload;
    },
  }
});

export const {
  resetCanvas,
  setCanvasState,
  setDimensions,
  setPlaying,
  setFrame
} = canvas.actions;

export default canvas.reducer;